import { createFileRoute } from '@tanstack/react-router';
import { JourneysWizardStepHandoff } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';
import { validateDetailSearch } from './-import-detail-search';

/** The legacy detail URL. Flag off the embedded app renders; flag on it forwards to the migrated one. */
function JourneysImportDetailRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysWizardStepHandoff step="detail" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/imports/$importId/')({
  validateSearch: validateDetailSearch,
  component: JourneysImportDetailRoute,
});
